export const SHORT_TASK_QUESTIONS_2 = [

    {
        id: 1,
        type: '選擇題',
        text: '1.<br/>「購買航海圖的委託人可選擇諸多裝飾性元素，再由製圖師或是在製圖師工作坊裡任職的專業藝術家繪製在底圖上。這些可供選擇的裝飾元素包括手繪城市圖像、象徵城市政治掌權者的旗幟、羅盤方位圖，以及山脈、河流、船隻等圖案，還有若干地圖中出現的海怪。這類航海圖更為精緻，因而更為昂貴──滿是裝飾性元素的航海圖甚至比實用性的航海圖貴上十倍──其並非用於導航，而是供王室和貴族收藏、展示之用。」',
        question: '根據這段文字，下列關於繪有海怪圖像航海圖的敘述何者正確？',
        options: [
            { text: 'A.	裝飾元素由製圖師決定', },
            { text: 'B.	清楚標示海怪所在位置', },
            { text: 'C.	作品絕多數為船長擁有 ', },
            { text: 'D.	該圖無法於航行中使用', },
        ],
        background: '#F8FAFB'
    }, {
        id: 2,
        type: '選擇題',
        text: '2.<br/>「好的圍棋要慢慢地下，好的生活歷程要細細品味；不要著急把棋盤下滿，也不要匆忙的走人生之路。」',
        question: '上述語句內容所要表達的意思為何?',
        options: [
            { text: 'A. 人生短暫，宜好好生活，不要心急。', },
            { text: 'B. 圍棋比賽時，可以慢慢想如何下子。', },
            { text: 'C. 人生就如下棋般，須思考如何行事。', },
            { text: 'D. 下圍棋時，應考量棋子的空間分佈。', },
        ],
        background: '#F8FAFB'

    }, {
        id: 3,
        type: '選擇題',
        text: '3.<br/>小丸子在網上看到一則帖文：「打開薯片才發現，原來空氣也是需要錢的！」',
        question: '這句話想要表達的涵義最有可能是什麼？',
        options: [
            { text: 'A. 袋內注入氣體，有助於維持食物的品質，所以空氣也算成本。' },
            { text: 'B. 諷刺產品內容物太少，包裝內充飽的氣體反而讓人覺得無言。' },
            { text: 'C. 打開袋子，薯片的香氣撲鼻而來，是零食包裝設計的巧思。' },
            { text: 'D. 從購入的薯片中，找到不肖商家品質管控不良的充分證據。' },
        ],
         background: '#F8FAFB'
    }, {
        id: 4,
        type: '選擇題',
        text: '4.<br/>「近年，法國鄉村出現很多乍看之下匪夷所思的爭議，新搬來的居民受不了鄉村常見的雞啼、蟬鳴等聲音，將他們的鄰居一狀告上法院，不僅讓老住戶被告得一頭霧水，更讓許多法國民眾開始思考起法國鄉村真正的樣貌。是以近日法國參議院通過一部法案，正式認可鄉村常聽見的雞啼、蛙鳴等聲音，都是法國鄉村『感官遺產』的一部分，未來也都在法國法律的保障範圍內，希望能藉此解決多年來都市民眾和鄉村居民間的爭議。」',
        question: '這段報導內容運用了何種寫作方式？',
        options: [
            { text: 'A. 先因後果', },
            { text: 'B. 先總後分', },
            { text: 'C. 觀點對比', },
            { text: 'D. 歸納論證', }
        ],
        background: '#F8FAFB'
    }
]